import type { FC } from 'react';
import React from 'react';
import styled from 'styled-components';

import { useTranslation } from '@lt/localization';
import GoToHotelContainer from '../../../../components/GoToHotel/GoToHotelContainer';
import { getPriceNoticeText } from './utils';
import type { IPriceNotice } from './types';

const PriceNotice: FC<IPriceNotice> = (props) => {
  const { t } = useTranslation();
  const { direction, isPriceChangedSignificantly } = props;

  if (!direction) {
    return null;
  }

  const priceNoticeText = getPriceNoticeText({
    direction,
    isPriceChangedSignificantly,
  });
  const { title, description, isShowingHotelLink } = priceNoticeText;

  return (
    <Container className="checkout-price-notice">
      <Title>{title}</Title>
      <Description>{description}</Description>

      {isShowingHotelLink && (
        <GoToHotelContainer className="lt-button-link" functional={false}>
          {t('checkout.priceNotice.title')}
        </GoToHotelContainer>
      )}
    </Container>
  );
};

const Container = styled.div`
  color: #17181a;
  font-size: 14px;
`;

const Title = styled.div`
  font-weight: bold;
`;

const Description = styled.div`
  white-space: pre-line;
  margin-top: 4px;
`;

export default PriceNotice;
